// extracted by mini-css-extract-plugin
export default {"box":"THSjx9UY4f3VkbPCd8XN","submitRow":"p9pUkVXI_WOo1I2AXALY"};